<template>
  <div>
    <v-breadcrumbs :items="breadcrumbs" class="mb-0">
      <template #prepend>
        <v-icon icon="mdi-home" size="small" />
      </template>
    </v-breadcrumbs>

    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card rounded="xl" elevation="2">
            <v-tabs v-model="tab" color="primary" :touch="false" hide-slider="false"  next-icon="mdi-arrow-right-bold-box-outline"
                    prev-icon="mdi-arrow-left-bold-box-outline"
                    show-arrows>
              <v-tab value="EducationalQualification" class="font-weight-bold"> সশিক্ষাগত যোগ্যতা</v-tab>
              <v-tab value="ProfessionalCertificate" class="font-weight-bold">পেশাগত সনদ</v-tab>
            </v-tabs>
            <v-divider />
            <v-window v-model="tab" :touch="false">
              <!-- Parents -->
              <v-window-item value="EducationalQualification">
                <v-card-text>
                  <EducationalQualification />
                </v-card-text>
              </v-window-item>

              <v-window-item value="ProfessionalCertificate">
                <v-card-text>
                  <ProfessionalCertificate />
                </v-card-text>
              </v-window-item>
            </v-window>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

import EducationalQualification from "@/components/pages/PMIS/EducationalInformation/EducationalQualification.vue";
import ProfessionalCertificate from "@/components/pages/PMIS/EducationalInformation/ProfessionalCertificate.vue";

export default {
  name: "EducationalInformation",

  components: {
    EducationalQualification,
    ProfessionalCertificate

  },

  data() {
    return {
      tab: "EducationalQualification",

      /* Breadcrumb */
      breadcrumbs: [
        {
          title: "Dashboard",
          disabled: false,
          to: "/dashboard",
        },
        {
          title: "Educational Information",
          disabled: true,
        },
      ],
    };
  },

  methods: {
  }
};
</script>
